import { Userdata } from "@/types/user";
import { useGetAuthenticatedUserQuery } from "@/api/authentication";

export const emptyUserData: Userdata = {
  organization: {
    name: "",
    id: "",
    features: [],
    dateFormat: "UK_EU",
    timeFormat: "24h",
    esgPortalConfig: [],
    contractFamilyDivisions: [],
  },
  features: [],
  pfRoles: [],
  avatar: "",
  id: "",
  name: "",
  username: "",
  email: "",
  phoneNumber: "",
  surname: "",
  isActive: false,
  canSelfServiceEmailChange: false,
  dateFormat: "UK_EU",
  timeFormat: "24h",
};

export interface AuthenticatedUser extends Userdata {
  isAuthenticated: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
}

export const useAuthenticatedUser = (): AuthenticatedUser => {
  const {
    data: userData = emptyUserData,
    isError,
    isFetching,
    isLoading,
  } = useGetAuthenticatedUserQuery(undefined, {
    // Consumed by every Drive row menu, grid avatar and banner: refetching on each mount turned one
    // page into dozens of pf-auth GETs. Feature/permission changes now show within 60 s instead.
    refetchOnMountOrArgChange: 60,
  });

  return {
    ...userData,
    isAuthenticated: !isError && !!userData.id,
    isLoading,
    isFetching,
    isError,
  };
};
